module.exports = __webpack_public_path__ + "static/SMTA-32dc74f661088089d857e3f68ff7ff52.png";